import React, { useState, useEffect, useRef, useMemo } from 'react';
import styled from '@emotion/styled';
import { useBrandDetails } from 'dw-au-react-components';

const StyleAwards = styled.div`
	.product__accolades.showAll {
		max-height: 60px;
		overflow: hidden;
		transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
	}
	.product__accolades.showAll.active {
		max-height: 999px;
		transition: max-height 0.5s ease-in-out;
	}
	.product__accolades {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: wrap;
	}
	.product__accolades img {
		width: 45px;
		margin-right: 15px;
		margin-bottom: 15px;
		flex-shrink: 0;
	}
	.product__accolades__showAll {
		display: inline-block;
		width: 43px;
		height: 43px;
		border: 1px solid #e3e3e3;
		border-radius: 30px;
		text-align: center;
		font-size: 20px;
		line-height: 20px;
		padding: 11px 0;
		color: rgba(0, 0, 0, 0.87) !important;
		cursor: pointer;
		transition: background-color 0.3s ease-in-out !important;
		flex-shrink: 0;
		text-decoration: none !important;

		position: absolute;
		right: 0;
		top: 0;
	}
	.product__accolades.showAll.active .product__accolades__showAll i {
		transform: rotate(180deg);
	}
	.product__accolades__showAll i {
		transition: transform 0.3s ease-in-out;
	}
`;

const Awards = ({ accolades, showViewAll = true }) => {
	const [showMore, setShowMore] = useState(false);
	const [showMoreBtn, setShowMoreBtn] = useState(false);
	const { tag } = useBrandDetails();

	const domainLiveURL = useMemo(() => {
		if (tag === 'adc') {
			return 'https://www.theaustralianwine.com.au';
		}
		if (tag === 'newstf') {
			return 'https://www.news24wine.com.au';
		}
		if (tag === 'vir') {
			return 'https://www.virginwines.com.au';
		}
		if (tag === 'law') {
			return 'https://www.laithwaites.co.nz';
		}
		if (tag === 'vws') {
			return 'https://redemption.virginwines.com.au';
		}
		return 'https://www.laithwaites.com.au';
	}, [tag]);

	const inputRef = useRef(null);

	useEffect(() => {
		const handleResize = () => {
			setShowMoreBtn(inputRef.current?.scrollHeight > 60);
		};

		setTimeout(() => {
			handleResize();
		}, 500);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	});

	return (
		<StyleAwards>
			{accolades?.length > 0 ? (
				<div
					ref={inputRef}
					className={`product__quick-view__awards position-relative product__accolades mb-15 d-flex flex-wrap showAll pr-40 ${
						showMore ? 'active' : ''
					}`}
				>
					{showViewAll && showMoreBtn ? (
						<div
							className={`product__accolades__showAll`}
							title='Click to View All'
							onClick={() => setShowMore(!showMore)}
						>
							<i className='fa fa-angle-down'></i>
						</div>
					) : null}
					{accolades.map((award, index) => {
						const {
							accoladeCategoryText,
							accoladeDescription,
							accoladeNameText,
							levelTypeDesc,
							awardTypeDesc,
							accoladeYear,
						} = award || {};

						const accoladeLevelSlug = accoladeDescription
							?.replace(/ /g, '_')
							.toLowerCase();
						let awardImageURL = '';
						let basePathImage = `${domainLiveURL}/images/au/common/accolades/${accoladeDescription}pts`;
						switch (accoladeCategoryText) {
							case 'Points':
								awardImageURL =
									accoladeNameText === 'James Halliday Wine Companion'
										? `${basePathImage}_halliday.svg`
										: `${basePathImage}.svg`;
								break;
							case 'Stars':
								awardImageURL = `${domainLiveURL}/images/au/common/accolades/${accoladeLevelSlug}_stars.svg`;
								break;
							case 'Trophy':
								awardImageURL = `${domainLiveURL}/images/au/common/accolades/trophy.svg`;
								break;
							default:
								awardImageURL = `${domainLiveURL}/images/au/common/accolades/${accoladeLevelSlug}.svg`;
						}

						const titleParts = [
							levelTypeDesc,
							awardTypeDesc,
							accoladeNameText ? `${accoladeNameText},` : '',
							accoladeYear,
						]
							.filter(Boolean)
							.join(' ');

						return (
							<div key={`${index}_${accoladeNameText}`}>
								<img
									src={awardImageURL}
									alt='Accolade'
									title={titleParts}
									className='d-inline-block mr-15'
								/>
							</div>
						);
					})}
				</div>
			) : null}
		</StyleAwards>
	);
};

export default Awards;
